import { IMusicUploadDTO } from '@/modules/musics/dto/music-upload.dto';
import { IMusicUpload } from '@/modules/musics/entities/music-upload.entity';

export class MusicUploadMapper {
  public static toPresentation(music: IMusicUploadDTO): IMusicUpload {
    return {
      uuid: music.uuid,
      name: music.nome,
      description: music.descricao,
      presignedUrl: music.presignedUrl,
    };
  }

  public static toDTO(music: IMusicUpload): IMusicUploadDTO {
    return {
      uuid: music.uuid,
      nome: music.name,
      descricao: music.description,
      presignedUrl: music.presignedUrl,
    };
  }
}
